<template>
  <div class="alert alert-danger text-center my-4">
    {{ trans("auth.noAccessToSsoPatient") }}
  </div>
</template>
